import { useAppDispatch, useAppSelector } from 'appState/store'
import CloseIconPlaceholder from 'assets/images/icons/CloseIconPlaceholder.svg'
import DoNotRepeat from 'assets/images/icons/DoNotRepeat.svg'
import { Drawer } from 'components/Drawer/Drawer'
import { getBatchEOBPartDetails, getBatchResults } from 'features/autocheck/autoCheckApi'
import { BatchProcessingStatus, BatchTabType, BatchType } from 'features/autocheck/types'
import { ClaimStatusOption, getAppealStatusOptions, resolveStatusDisplayName } from 'features/claims/claimsApi'
import { updateAllClaimsRoute } from 'features/claims/claimsSlice'
//import { useUserProfile } from 'features/settings/settingsHooks'
import { useEffect, useState } from 'react'
import { Offcanvas } from 'react-bootstrap'
import { FaArrowRight, FaClock, FaInfoCircle, FaRetweet } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { Badge, Button, Card, Tooltip } from '@outbound-ai/ursa'
import styled from 'styled-components'
import { PositionEnum } from 'types/cssTypes'

import moment from 'moment'
import { notificator } from 'utils/notificator/notificator'
import { getTntIdForNavigation } from 'utils/tenantUrlUtils'
import { getBatchErrors } from '../BatchErrors'
import { eobReceivedTime } from '../EOBReceived'
import { formatActionDownload, formatBatchType, IprocessingStatus, processingStatusMap } from '../formatter'
import { BatchTooltipText } from '../tootlTipText'
import { BatchCount } from './batchCount'
import { BatchFile } from './batchFiles'
import { BatchResultclaimStatus } from './batchResultConfig'
import BarChart from './claimStatusCountChart'

interface IClaimStatus {
  status: string
  title: string
  count: number
  variant: any
}

interface IStatusCount {
  label: string
  value: number
}

// One bar per AppealStatus enum value (in enum order); keys the enum doesn't know still get their own bar
const toAppealStatusChartData = (options: ClaimStatusOption[], counts: Record<string, number> = {}): IStatusCount[] => {
  const totals = new Map(options.map((option) => [option.name, 0]))
  Object.entries(counts).forEach(([status, count]) => {
    const label = resolveStatusDisplayName(options, status)
    totals.set(label, (totals.get(label) ?? 0) + (Number(count) || 0))
  })
  return Array.from(totals, ([label, value]) => ({ label, value }))
}

export const formatBatchDetails = (params: any) => {
  const [show, setShow] = useState(false)
  const [batchResult, setBatchResult] = useState<any>({})
  const [batchErrorsData, setBatchErrors] = useState<any>({})
  const [appealStatusChartData, setAppealStatusChartData] = useState<IStatusCount[]>([])
  const [bathDetailsData, setBathDetailsData] = useState<any>([])
  const [isLoadingEobPart, setIsLoadingEobPart] = useState<boolean>(false)

  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { root } = useAppSelector((state) => state.batch)
  //const { user } = useAppSelector((state) => state.auth)
  //const { data } = useUserProfile(user?.id)

  async function batchError() {
    const batchErrors = await getBatchErrors(params.data.batchId, params.data.batchType)
    setBatchErrors(batchErrors)
  }

  const batchCompletedTime = moment(params.data.lastUpdatedTime)

  const duration = moment.duration(batchCompletedTime.diff(moment(params.data.created)))

  useEffect(() => {
    if (show) {
      BatchResultclaimStatus.forEach((item: IClaimStatus) => {
        item.count = 0
      })
      setAppealStatusChartData([])
      getBatchResults(params.data.batchId).then((res) => {
        if (res) {
          setBatchResult(res)
          // filter Claim Status Count from res.claimStatusCounts
          const statusKey = Object.keys(res.claimStatusCounts)
          statusKey.forEach((status) => {
            BatchResultclaimStatus.forEach((item: IClaimStatus) => {
              if (item.status === status) {
                item.count = res.claimStatusCounts[status]
              }
            })
          })
          getAppealStatusOptions()
            .catch((error) => {
              console.error('Error loading appeal statuses for batch results:', error)
              return []
            })
            .then((options) => setAppealStatusChartData(toAppealStatusChartData(options, res.appealStatusCounts)))
          batchError()
        }
      })
      if (
        params.data.batchType === BatchType.Claim_Autocheck_EOB &&
        (parseInt(params.data.processingStatus) === BatchProcessingStatus.Complete ||
          parseInt(params.data.processingStatus) === BatchProcessingStatus.Cancelled) &&
        params.data.eobReceivedCount !== 0
      ) {
        handelPartView()
      }
    }
  }, [show])

  const handelPartView = () => {
    getBatchEOBPartDetails(params.data.batchId, '')
      .then((res) => {
        if (res?.data?.eobZipFileCount !== 0) {
          setBathDetailsData(res.data.eobPartFileList)
          setIsLoadingEobPart(false)
        } else {
          setIsLoadingEobPart(true)
        }
      })
      .catch((error) => {
        setIsLoadingEobPart(true)
        notificator.notify({
          type: 'error',
          heading:
            error.response?.status === 400
              ? error.response?.data?.detail
              : 'Failed to fetch EOB part details. Please try again later.',
        })
      })
  }

  const redirectToClaimList = () => {
    dispatch(
      updateAllClaimsRoute({
        batchId: batchResult.batchId,
        batchCode: batchResult.batchCode,
      }),
    )
    const tenantId = getTntIdForNavigation()
    navigate(tenantId ? `/${tenantId}/claims` : '/claims')
  }

  const BatchDetailsHeader = () => {
    const { processingStatus } = params.data
    const batch = processingStatusMap[processingStatus as keyof IprocessingStatus] || processingStatusMap[0]
    return (
      <BatchHeader>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div> Batch {params.data.batchCode}</div>
            <Badge variant="tag" fill="light" type="default" icon={batch.icon}>
              {batch.label}
            </Badge>
          </Offcanvas.Title>
        </Offcanvas.Header>
      </BatchHeader>
    )
  }

  return (
    <Div>
      <span className="action">
        <Button onClick={() => setShow(true)} size="small" radius="rounded" variant="primary-outline">
          {' '}
          View Details{' '}
        </Button>
      </span>

      <Drawer
        show={show}
        header={<BatchDetailsHeader />}
        placement="end"
        handleClose={() => setShow(false)}
        width="45rem"
      >
        <BatchResultDrawer
          repeatCall={batchResult.repeatCallFlag}
          isImportOnly={params.data.batchType === BatchType.Claim_Import}
        >
          <div className="batch-info">
            <div className="batch-tags">
              <>{formatBatchType(params.data.batchType)}</>
              {params.data.batchType != BatchType.Claim_Import && (
                <div className="repeated-call">
                  <Tooltip
                    tooltipText={
                      <>
                        {batchResult.repeatCallFlag ? BatchTooltipText.repeatCallsOn : BatchTooltipText.repeatCallOff}
                      </>
                    }
                    tooltipStyles={{ 'min-width': '15rem', transform: 'translateY(36%) translateX(-27%)' }}
                    position={PositionEnum.bottom}
                    positionTooltipArrow={10}
                  >
                    {batchResult.repeatCallFlag ? (
                      <Badge type="info" fill="light" variant="tag" icon={<FaRetweet />}>
                        Repeat Calls On
                      </Badge>
                    ) : (
                      <Badge type="grey" fill="dark" variant="tag" icon={<img src={DoNotRepeat} />}>
                        Repeat Calls Off
                      </Badge>
                    )}
                  </Tooltip>
                </div>
              )}
            </div>

            <div className="batch-actions">
              {root != BatchTabType.Claims && root != BatchTabType.Processing && (
                <Button variant="secondary" radius="rounded" size="small" onClick={() => redirectToClaimList()}>
                  View Claims <FaArrowRight />
                </Button>
              )}
              {formatActionDownload(params, root, bathDetailsData)}
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'left',
              marginBottom: '1rem',
              height: '100%',
              color: '#9B6D24',
              fontWeight: 'bold',
            }}
          >
            {isLoadingEobPart ? (
              <p>
                We&apos;re preparing your EOBs for download. Please close and re-open the batch detail view to access
                your EOB zip file(s).
              </p>
            ) : null}
          </div>
          {params.data.batchType != BatchType.Claim_Import &&
            (root === BatchTabType.Processed || root === BatchTabType.EOB) && (
              <div className="batch-counter">
                <Card>
                  <h2>{params.data.autoChecked}</h2>
                  <p>Calls Placed</p>
                  <span className="time">
                    <div>
                      {' '}
                      Total time: {Math.floor(duration.asHours())}h {duration.minutes()}m
                    </div>
                    <Tooltip
                      tooltipText={BatchTooltipText.claimAutoChecked}
                      position={PositionEnum.bottom}
                      tooltipStyles={{ 'min-width': '19rem', transform: 'translateY(74%) translateX(-12%)' }}
                      positionContent={80}
                      positionTooltipArrow={10.5}
                    >
                      <FaInfoCircle />
                    </Tooltip>
                  </span>
                </Card>
                {params.data.batchType === BatchType.Claim_Autocheck_EOB && root === BatchTabType.Processed && (
                  <Card>
                    <h2>{params.data.eobReceivedCount}</h2>
                    <p>EOBs matched</p>
                  </Card>
                )}
                {params.data.batchType === BatchType.Claim_Autocheck_EOB && root === BatchTabType.EOB && (
                  <Card>
                    <h2>
                      <FaClock />
                    </h2>
                    <p>Awaiting EOBs</p>
                    <span className="time">
                      <div> Time left: {eobReceivedTime(params)}</div>
                      <Tooltip
                        tooltipText={BatchTooltipText.eobReceived}
                        position={PositionEnum.bottom}
                        tooltipStyles={{ 'min-width': '19rem', transform: 'translateY(68%) translateX(-42%)' }}
                        positionContent={80}
                        positionTooltipArrow={41}
                      >
                        <FaInfoCircle />
                      </Tooltip>
                    </span>
                  </Card>
                )}
              </div>
            )}
          {(params.data.batchType === BatchType.Claim_Autocheck ||
            params.data.batchType === BatchType.Claim_Autocheck_EOB) &&
            (root === BatchTabType.Processed || root === BatchTabType.EOB) && (
              <div className="batch-status">
                <h2>Extracted Claim Status Overview </h2>
                <Card>
                  <BarChart
                    data={BatchResultclaimStatus.map((item) => ({
                      label: item.title,
                      value: item.count,
                    }))}
                  />
                </Card>
              </div>
            )}
          {params.data.batchType === BatchType.Claim_ASC && root === BatchTabType.Processed && (
            <div className="batch-status">
              <h2>Extracted Appeal Status Overview</h2>
              <Card>
                <BarChart data={appealStatusChartData} />
              </Card>
            </div>
          )}
          <div className="batch-count">
            <h2>Claim Count</h2>
            <BatchCount params={params} batchResult={batchResult} batchErrorsData={batchErrorsData} root={root} />
          </div>

          <div className="batch-files">
            <h2>File Details</h2>
            <BatchFile params={params} root={root} />
          </div>
        </BatchResultDrawer>
      </Drawer>
    </Div>
  )
}

const BatchHeader = styled.div`
  .offcanvas-title {
    ${({ theme }) => theme.typography.h4.medium};
    color: ${({ theme }) => theme.colors.primary.neutral};
    display: flex;
    gap: ${({ theme }) => theme.spacing.s};
    align-items: center;
  }
  .offcanvas-header {
    padding: ${({ theme }) => theme.spacing.s} 0 !important;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey.lighter}!important;
    margin: 0 ${({ theme }) => theme.spacing.l}!important;
    .btn-close {
      border-radius: 100px;
      opacity: 1;
      background-size: 11px 11px;
      background: url(${CloseIconPlaceholder}) ${({ theme }) => theme.colors.primary.lighter} center;
      background-repeat: no-repeat;
      outline: 0;
    }
  }
`

const Div = styled.div`
  display: flex;
  .offcanvas .offcanvas-body {
    padding: ${({ theme }) => theme.spacing.l}!important;
  }
`

const BatchResultDrawer = styled.div<{ repeatCall: boolean; isImportOnly: boolean }>`
  padding: ${({ theme }) => theme.spacing.xxs};
  .batch-info {
    display: flex;
    justify-content: space-between;
    margin-bottom: ${({ theme }) => theme.spacing.l};
    .batch-tags {
      display: flex;
      gap: ${({ theme }) => theme.spacing.xxxs};
      align-items: center;
    }
    .batch-actions {
      display: flex;
      gap: ${({ theme }) => theme.spacing.xxs};
    }
    .repeated-call {
      display: flex;
      align-items: center;
      gap: ${({ theme }) => theme.spacing.xxxs};
      .retweet-icon {
        color: ${({ theme }) => theme.colors.primary.neutral};
      }
      img {
        /* update image color with filter it should be dark grey */
        filter: invert(0.5);
      }
    }
  }
  .batch-status {
    main {
      padding: 0px ${({ theme }) => theme.spacing.s}!important;
      margin: ${({ theme }) => theme.spacing.s}!important;
    }
    h2 {
      margin-top ${({ theme }) => theme.spacing.s};
      ${({ theme }) => theme.typography.m.medium};
      color: ${({ theme }) => theme.colors.neutral.neutral};
      margin-bottom: ${({ theme }) => theme.spacing.xs};
    }
  }
  .batch-count {
    h2 {
      margin-top ${({ theme }) => theme.spacing.s};
      ${({ theme }) => theme.typography.m.medium};
      color: ${({ theme }) => theme.colors.neutral.neutral};
      margin-bottom: ${({ theme }) => theme.spacing.xs};
    }
  }
  .batch-files {
    h2 {
      margin-top ${({ theme }) => theme.spacing.s};
      ${({ theme }) => theme.typography.m.medium};
      color: ${({ theme }) => theme.colors.neutral.neutral};
      margin-bottom: ${({ theme }) => theme.spacing.xs};
    }
  }
  .batch-counter{
   display: flex;
    gap: ${({ theme }) => theme.spacing.xs};
    main {
      margin: ${({ theme }) => theme.spacing.s}!important;
      padding: 0px!important
    }
    h2 {
      ${({ theme }) => theme.typography.h4.medium};
      color: ${({ theme }) => theme.colors.info.neutral};
      margin:0px!important;
      padding: 0px!important;
    }
    p{
      ${({ theme }) => theme.typography.s.medium};
      color: ${({ theme }) => theme.colors.neutral.neutral};


    }

    .time {
        ${({ theme }) => theme.typography.s.normal};
        color: ${({ theme }) => theme.colors.grey.dark};
        display : inline-flex;
        gap: ${({ theme }) => theme.spacing.xxxs};
         svg{
              color: ${({ theme }) => theme.colors.grey.neutral};
}
      }
  }

`
